export const PATH = {
  LOGIN: '/',
  HOME: '/home',
  LINE_CONNECTED: '/line-connected',
  QR_CODE: '/qr-code',
  QR_CODE_LOGIN: '/qr-code-login',
};
